import { catchNoErr } from '@/common/utils/catch-error';
import { axiosGet, axiosPost, axiosPut, axiosDelete } from './request';
/* eslint-disable */
export function _get() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // @ts-ignore
    return catchNoErr(axiosGet.apply(void 0, args));
}
/* eslint-disable */
export function _post() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // @ts-ignore
    return catchNoErr(axiosPost.apply(void 0, args));
}
/* eslint-disable */
export function _put() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // @ts-ignore
    return catchNoErr(axiosPut.apply(void 0, args));
}
/* eslint-disable */
export function _del() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // @ts-ignore
    return catchNoErr(axiosDelete.apply(void 0, args));
}
